export default __webpack_public_path__ + "static/media/error-close-red.4754adeb.svg";